import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AcquireShiftEntity } from '../../domain/entities/AcquireShiftEntity'
export class AcquireShiftModel extends AcquireShiftEntity {
  driverId?: number
  shiftId?: string
  constructor(dataDto: AcquireShiftEntity) {
    super()
    mapEntityProperties<AcquireShiftModel>(this, dataDto, {
      exclude: ['driver', 'shift'],
      map: {
        driverId: dataDto.driver?.id,
        shiftId: dataDto.shift?.id
      }
    })
  }
}
